enum BookingStatus {
	Active = 90,
	Cancelled = 100,
}

export default BookingStatus;